import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MapPickerDialogComponent } from '../shared/components/map-picker-dialog-component/map-picker-dialog-component';

export type MapPickerMode = 'view' | 'search';

export interface MapPickerResult {
    lat: number;
    lng: number;
    address?: string;
}

export interface MapPickerDialogData {
    mode?: MapPickerMode;
    lat?: number;
    lng?: number;
    address?: string;
    title?: string;
    zoom?: number;
}

@Injectable({ providedIn: 'root' })
export class MapPickerService {
    constructor(private dialog: MatDialog) { }

    open(data?: MapPickerDialogData): Observable<MapPickerResult | undefined> {
        const ref = this.dialog.open<MapPickerDialogComponent, MapPickerDialogData, MapPickerResult | undefined>(
            MapPickerDialogComponent,
            {
                data,
                width: '95vw',
                maxWidth: '1400px',
                height: '92vh',
                panelClass: 'map-picker-dialog-panel',
                autoFocus: false,
                restoreFocus: true,
            }
        );
        return ref.afterClosed();
    }
}